import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute('/ask/$schema')({
  validateSearch: z.object({ thread: z.string().optional().catch(undefined), q: z.string().optional().catch(undefined) }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/data', search: { view: 'ask', thread: search.thread, question: search.q }, replace: true })
  },
})
